const SkyscraperReducer = (state = {}, action) => {
  switch (action.type) {
    case 'UPDATE_SKIP_SKY':
      return action.data;
    default:
      return state;
  }
};

export {SkyscraperReducer};
